import includes from 'ramda/es/includes';
import getLocaleFromPathname from './getLocaleFromPathname';

export default (pathname, supportedLocales, defaultLocale) => {
  let win;
  try {
    win = window;
  } catch (e) {
    win = {location: {}}; // Support unit test environment
  }
  const path = pathname || win.location.pathname;
  const pathLocale = getLocaleFromPathname(path);
  if (includes(pathLocale, supportedLocales)) {
    return pathLocale;
  }
  return defaultLocale;
};
